import React, { ReactNode } from "react";

import { Skeleton } from "@packages/ds";

import * as Table from "ds/Table";

type Props = {
  children?: ReactNode;
};

export const TbodySkeleton = (props: Props) => (
  <Table.Tbody>
    {Array.from(new Array(3)).map((_, index) => (
      <Skeleton key={index} synchronize>
        <Table.Tr>
          {props.children ? (
            props.children
          ) : (
            <>
              <Table.Td width="45%">
                <Skeleton.Square height="18px" width="90%" />
              </Table.Td>
              <Table.Td width="45%">
                <Skeleton.Square height="18px" width="90%" />
              </Table.Td>
              <Table.Td width="32px">
                <Skeleton.Square height="32px" width="32px" />
              </Table.Td>
            </>
          )}
        </Table.Tr>
      </Skeleton>
    ))}
  </Table.Tbody>
);
